export const API_LOT_TIMEOUT = 30000;

export const AUCTION_TITLE_TRUNCATION_LENGTH = 40;
export const NAVBAR_LOGO_HEIGHT = 65;
export const LOGIN_FORM_LOGO_HEIGHT = 100;

export const LOT_GRID_MIN_REFETCH_RATE = 5 * 1000;

export const MAX_MOBILE_WIDTH = 768;

export const LARGE_WINDOW_SIZE = 1920;

export const GST_RATE = 5;
export const PST_RATE = 0;
// This is a fallback for if a user does not have a valid bidder group. It shouldn't
// be needed unless something's gone wrong.
export const BUYER_PREMIUM = 17;

export const MAX_ITEMS_IN_CATEGORY_ROW = 8;

export const EMPTY_SENTINEL_VALUE = "EMPTY EMPTY eMpTy EMPTY EMPTY";

export const COMMISSION_RATE = 0.3;
export const MINIMUM_COMMISSION_FEE = 35;

export const EMAIL_SENDING_DELAY = 100; // Capped at 14 emails/second
// 7 days, in ms.
// export const GRACE_PERIOD_DURATION = 7 * 24 * 60 * 60 * 1000;
export const GRACE_PERIOD_DURATION = 7 * 24 * 60 * 60 * 1000;

// export const GRACE_PERIOD_STRING = "7 days";
export const GRACE_PERIOD_STRING = "7 days";

export const AUCTION_BID_MAX = 30000;
export const AUCTION_MAX_RAMP_UP_PERCENTAGE = 800;

export const PAST_AUCTIONS_PAGE_SIZE = 5;
export const AUCTION_CATALOGUE_DEFAULT_PAGE_SIZE = 20;
